import { EmailService } from 'src/app/services/integrations/email/email.service';
import { ToastrService } from "ngx-toastr";

class EmailAttachmentHelper {
    selectedAttachments = {};

    attachmentError = undefined;

    inprogress = {};

    constructor(
        private emailService: EmailService,
        private attachment_base_url: string,
        private toast: ToastrService
    ) { }

    uploadFile(file) {
        let formData = new FormData();

        formData.append('attachment', file[0]);
        const { name, size, mimetype } = file[0];
        if (size < 18750000) {
            const attachment_name = name.replace(/\s/g, "_");

            this.selectedAttachments[attachment_name] = {
                done: false,
                mimetype,
                name: attachment_name,
                size,
                uploaded: 0,
                url: '',
            }

            this.emailService.uploadAttachment(formData).subscribe((chunk: any) => {
                if (chunk.type == 1) return;
                if (chunk.type == 4) {
                    let url = `${this.attachment_base_url}/${attachment_name}`;
                    this.emailService.getAttachmentBase64String(attachment_name).subscribe((response: any) => {
                        this.setAttachmentData(attachment_name, url, 100, true, response);
                    });
                } else {
                    const total = this.selectedAttachments[attachment_name].size;
                    let percent = chunk.loaded / total;
                    percent = isNaN(percent) ? 0 : Math.round(percent * 100);
                    this.selectedAttachments[attachment_name].uploaded = percent;
                }
            });
            return;
        }
        this.toast.error(`File attachment limit is 150MB`)

    }

    reduceSelectedAttachmentsToList() {
        const attachmentArray = [];
        for (let prop in this.selectedAttachments) {
            attachmentArray.push(this.selectedAttachments[prop]);
        }

        return attachmentArray;

    }

    removeAttachment(name) {
        delete this.selectedAttachments[name];
    }

    setAttachmentData(name: string, url: string, progress: number, isDone: boolean = false, data: any = null) {
        if (data) {
            this.selectedAttachments[name].encoded = data.encoded;
            this.selectedAttachments[name].mimetype = data.mimetype;
        }
        this.selectedAttachments[name].done = isDone;
        this.selectedAttachments[name].uploaded = progress;
        this.selectedAttachments[name].url = url;
    }

    displayError(message) {
        this.attachmentError = message;
        setTimeout(() => {
            this.attachmentError = undefined;
        }, 2000);
    }
}

export default EmailAttachmentHelper;